"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendRestorePasswordCodeSuccess = exports.RestorePasswordSucccess = exports.ResendEmailTwoFactorSucccess = exports.ConfirmEmailWarning = exports.AccountCreatedSuccess = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ui = require("../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ResendEmailTwoFactorSucccess = function ResendEmailTwoFactorSucccess() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('login.resendCode.description'),
    type: "success",
    title: t('login.resendCode.title')
  });
};
exports.ResendEmailTwoFactorSucccess = ResendEmailTwoFactorSucccess;
var RestorePasswordSucccess = function RestorePasswordSucccess() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('restore.passwordChanged.description'),
    type: "success",
    title: t('restore.passwordChanged.title')
  });
};
exports.RestorePasswordSucccess = RestorePasswordSucccess;
var SendRestorePasswordCodeSuccess = function SendRestorePasswordCodeSuccess() {
  var _useTranslation3 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('restore.sendCode.description'),
    type: "success",
    title: t('restore.sendCode.title')
  });
};
exports.SendRestorePasswordCodeSuccess = SendRestorePasswordCodeSuccess;
var AccountCreatedSuccess = function AccountCreatedSuccess() {
  var _useTranslation4 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('signUp.accountCreated.description'),
    type: "success",
    title: t('signUp.accountCreated.title')
  });
};
exports.AccountCreatedSuccess = AccountCreatedSuccess;
var ConfirmEmailWarning = function ConfirmEmailWarning() {
  var _useTranslation5 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation5.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('signUp.confirmEmail.description'),
    type: "warning",
    title: t('signUp.confirmEmail.title')
  });
};
exports.ConfirmEmailWarning = ConfirmEmailWarning;